<div class="grid">
    <div class="col-12">
        <div class="card" *ngIf="!verificarPermissao('PERM_LISTAR_CENTRAL_CLIENTE')">
            <div style="text-align: center">
                <h4>Você não possui permissão de acesso essa página!</h4>
            </div>
        </div>
        <div class="card" *ngIf="verificarPermissao('PERM_LISTAR_CENTRAL_CLIENTE')">
            <div *ngIf="messagemVisivel" class="field col-12 md:col-12">
                <p-messages
                    [(value)]="messages"
                    [enableService]="false"
                    [closable]="true"
                ></p-messages>
            </div>
            <p-table
                #dt1
                [value]="retornosClientes"
                dataKey="id"
                [rows]="itensPaginados ? itensPaginados.size : 0"
                [loading]="loadingTable"
                [rowHover]="true"
                [paginator]="true"
                (onLazyLoad)="onLazyLoad($event)"
                [totalRecords]="itensPaginados ? itensPaginados.totalElements : 0"
                [lazy]="true"
                [showCurrentPageReport]="true"
                responsiveLayout="stack"
                styleClass=" p-datatable-sm"
                currentPageReportTemplate="Mostrando {first} ao {last} de {totalRecords} registros"
            >
                <ng-template pTemplate="caption">
                    <div class="flex justify-content-between flex-column md:flex-row">
                        <div class="flex flex-column md:flex-row">
                            <div class="p-fluid md:w-12rem md:mr-2">
                                <label>Data Inicial</label>
                                <p-calendar
                                    [readonlyInput]="true"
                                    [showIcon]="true"
                                    dateFormat="dd/mm/yy"
                                    [showButtonBar]="true"
                                    ngModel
                                    [(ngModel)]="dataFiltroInicio"
                                    styleClass="p-button-outlined"
                                    appendTo="body"
                                    (ngModelChange)="filtrar()"
                                    placeholder="Selecione"
                                ></p-calendar>
                            </div>
                            <div class="p-fluid md:w-12rem md:mr-2">
                                <label>Data Final</label>
                                <p-calendar
                                    [readonlyInput]="true"
                                    [showIcon]="true"
                                    dateFormat="dd/mm/yy"
                                    [showButtonBar]="true"
                                    ngModel
                                    [(ngModel)]="dataFiltroFinal"
                                    appendTo="body"
                                    (ngModelChange)="filtrar()"
                                    placeholder="Selecione"
                                ></p-calendar>
                            </div>
                        </div>

                        <div class="p-fluid mt-3 md:mt-4">
                            <div class="flex">
                                <span class="p-input-icon-left">
                                    <i class="pi pi-search"></i>
                                    <input
                                        pInputText
                                        type="text"
                                        #filter
                                        (input)="buscar($event)"
                                        placeholder="Buscar"
                                        class="w-full"
                                    />
                                </span>
                                <span class="ml-2">
                                    <button
                                        pButton
                                        class="p-button-outlined"
                                        icon="pi pi-filter-slash"
                                        pTooltip="Limpar Filtros"
                                        (click)="limpar(dt1)"
                                    ></button>
                                </span>
                            </div>
                        </div>
                    </div>
                </ng-template>
                <ng-template pTemplate="header">
                    <tr>
                        <th pSortableColumn="nomeCliente">
                            Cliente
                            <p-sortIcon field="nomeCliente"></p-sortIcon>
                        </th>

                        <th pSortableColumn="descricaoItem">
                            Item
                            <p-sortIcon field="descricaoItem"></p-sortIcon>
                        </th>
                        <th pSortableColumn="dataRetorno">
                            Data Retorno
                            <p-sortIcon field="dataRetorno"></p-sortIcon>
                        </th>
                        <th>Contato</th>
                        <th>Email</th>
                        <th style="text-align: center">Ações</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-item>
                    <tr>
                        <td>
                            {{ item.nomeCliente }}
                        </td>
                        <td>
                            {{ item.descricaoItem }}
                        </td>
                        <td>
                            {{ item.dataRetorno | date: "dd/MM/yyyy" }}
                        </td>
                        <td>
                            {{ item.contato ? item.contato : "NÃO CADASTRADO" }}
                        </td>
                        <td>
                            {{ item.email ? item.email : "NÃO CADASTRADO" }}
                        </td>
                        <td style="text-align: center">
                            <button
                                type="button"
                                pButton
                                class="p-button-success mr-2"
                                icon="pi pi-whatsapp"
                                (click)="abrirDialogRetorno(item, 'WHATSAPP')"
                                pTooltip="WhatsApp"
                            ></button>
                            <button
                                type="button"
                                pButton
                                class="p-button-info"
                                icon="pi pi-envelope"
                                (click)="abrirDialogRetorno(item, 'EMAIL')"
                                pTooltip="E-mail"
                            ></button>
                        </td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage">
                    <tr>
                        <td colspan="7">Nenhum registro encontrado.</td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="loadingbody">
                    <tr>
                        <td colspan="7">Carregando clientes. Por favor aguarde.</td>
                    </tr>
                </ng-template>
            </p-table>
            <div class="formgroup">
                <div class="p-fluid p-formgrid grid justify-content-end">
                    <div class="col-12 md:col-4 flex justify-content-end">
                        <button
                            type="button"
                            pButton
                            class="p-button-outlined md:w-9rem mt-5"
                            icon="pi pi-arrow-left"
                            label="Voltar"
                            routerLink="/apps/central-cliente"
                        ></button>
                    </div>
                </div>
            </div>
            <p-dialog
                [header]="headerDialogRetorno"
                [(visible)]="exibirDialogRetorno"
                [modal]="true"
                [style]="{ width: '30vw' }"
                [draggable]="false"
                [resizable]="false"
                [closable]="true"
                (onHide)="fecharDialogRetorno()"
            >
                <ng-template pTemplate="header">
                    <div class="inline-flex align-items-center justify-content-center gap-2">
                        <i
                            [ngClass]="tipoMensagem === '1' ? 'pi pi-whatsapp' : 'pi pi-envelope'"
                        ></i>
                        <span class="text-xl font-bold white-space-nowrap">
                            {{ headerDialogRetorno }}
                        </span>
                    </div>
                </ng-template>

                <div class="p-fluid p-formgrid grid">
                    <div class="col-12">
                        <textarea
                            id="description"
                            type="text"
                            pInputTextarea
                            [rows]="10"
                            [(ngModel)]="conteudoMensagem"
                            style="resize: none"
                        ></textarea>
                    </div>
                    <div class="col-4">
                        <button
                            type="button"
                            pButton
                            label="Enviar"
                            class="p-button-outlined p-button-success"
                            (click)="enviarMensagem()"
                        ></button>
                    </div>
                </div>
            </p-dialog>
            <p-dialog
                header="Atenção"
                [(visible)]="exibirDialogSemContato"
                [modal]="true"
                [draggable]="false"
                [resizable]="false"
                [closable]="true"
                (onHide)="exibirDialogSemContato = false"
            >
                <div class="flex justify-content-between">
                    <p>Nenhum {{ textoDialogSemContato }} cadastrado para este cliente.</p>
                </div>
            </p-dialog>
        </div>
    </div>
</div>
